import $ from "jquery";
import { gsap } from "gsap";

export default class Top {

  public body : HTMLElement;
  public element : HTMLElement;
  private statement : HTMLElement;
  private content : NodeListOf<HTMLElement>;
  private nav : NodeListOf<HTMLElement>;

  constructor() {
    this.body = document.querySelector('body') as HTMLElement;
    this.element = document.querySelector('body.front') as HTMLElement;
    this.statement = document.querySelector('.js-statement') as HTMLElement;
    this.content = document.querySelectorAll('[data-statement]');
    this.nav = document.querySelectorAll('[data-statement-nav]');
  }

  init(): void {
    this.keyvisual();
    this.statementHoverHandler();

  }

  keyvisual(): void {

    gsap.fromTo('.kv__em', {
      filter: "blur(10px)",
      autoAlpha: 0,
      y: 10,
    }, {
      filter: "blur(0px)",
      duration: 1.4,
      autoAlpha: 1,
      y: 0,
    });

    gsap.fromTo('.kv__text', {
      filter: "blur(10px)",
      autoAlpha: 0,
      y: 10,
    }, {
      filter: "blur(0px)",
      duration: 1.4,
      autoAlpha: 1,
      delay: 0.3,
      y: 0,
    });

    gsap.fromTo('.kv__imgItem', {
      filter: "blur(10px)",
      autoAlpha: 0,
      scale: 1.1,
    }, {
      filter: "blur(0px)",
      duration: 1.4,
      autoAlpha: 1,
      scale: 1.0,
      delay: 0.9,
      stagger: 0.3,
    });

  }

  statementHoverHandler(): void {
    let prevNav:any = null;
    let prevContent:any = null;
    $("[data-statement-nav]").hover(function(e){

      $('[data-statement]').removeClass('is-active');
      $('[data-statement-nav]').removeClass('is-active');


      let nav = e.currentTarget as HTMLAnchorElement;
      let navname = $(nav).data('statement-nav');
      let thisContent = `[data-statement="${navname}"]`;
      $(nav).addClass('is-active');
      $(thisContent).addClass('is-active');
      prevNav = nav;
      prevContent = thisContent;
      // gsap.killTweensOf(thisContent);
      // gsap.to(thisContent, {
      //   duration: 0.3,
      //   autoAlpha: 1,
      //   ease: "none"
      // });
    }, function(e){

    });

  }




  // navCloseHandler(): void {
  //   this.body.classList.remove('nav-on');
  //   gsap.to('.spnav', {
  //     duration: 0.3,
  //     autoAlpha: 0
  //   });
  // }


  // anchorClickHandler(e: MouseEvent) {
  //   e.preventDefault();
  //   let nav = e.currentTarget as HTMLAnchorElement;
  //   // let queryname:string = nav.getAttribute('href') as string;
  //   let tag = document.querySelector(nav.hash) as HTMLElement;
  //   this.body.classList.remove('nav-on');
  // }

}
